"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChangeIndicator_meta_1 = require("../ChangeIndicator.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Icon_1 = __importDefault(require("../../../base/Icon/Icon"));

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Icon_1.default, ChangeIndicator_meta_1.CHANGE_INDICATOR_CATEGORY_KEY, ChangeIndicator_meta_1.CHANGE_INDICATOR_COMPONENT_KEY, ['icon']);